import {
  TypographyProps as MantineTypographyProps,
  Typography as MantineTypography,
} from '@mantine/core';

export type TypographyProps = MantineTypographyProps;

export const Typography = MantineTypography;

Typography.displayName = 'Typography';
